/**
 * External dependencies
 */
import { tns } from 'tiny-slider/src/tiny-slider.js';

const wrappers = document.querySelectorAll('.columnists-carousel');

if (0 !== wrappers.length) {
	wrappers.forEach(function (wrapper, key) {
		wrapper.setAttribute('id', 'columnists-carousel-' + key);
		tns({
			autoplayButtonOutput: false,
			autoHeight: false,
			mouseDrag: true,
			nav: false,
			loop: true,
			items: 1,
			container: wrapper.querySelector('.columnists__list'),
			speed: 400,
			swipeAngle: false,
			prevButton:
				'#columnists-carousel-' + key + ' .columnists__controls-prev',
			nextButton:
				'#columnists-carousel-' + key + ' .columnists__controls-next',
		});
	});
}
